import { CONNECTED_SERVICE_VALUES } from '@dawn/feature-config/widgets';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { queryKeys } from '@/hooks/queries/query-keys';
import { useConfigQuery } from '@/hooks/queries/use-config-query';
import { dashboardApi } from '@/lib/api';
import { useConnectedServicesStore } from '@/stores/connected-services';

/**
 * Copies the tenant's connected services into their store; render-only. Only
 * the Overview's widgets read them, so nothing is asked where it is off.
 */
export function ConnectedServicesSync({ enabled }: { enabled: boolean }): null {
  const overview = useConfigQuery().data?.policy.featureFlags.overview === true;
  const { data, isError } = useQuery({
    queryKey: queryKeys.connectedServices,
    queryFn: ({ signal }) => dashboardApi.getConnectedServices(signal),
    enabled: enabled && overview,
  });

  useEffect(() => {
    if (data) useConnectedServicesStore.setState({ services: data, settled: true });
    else if (isError) useConnectedServicesStore.setState({ settled: true });
  }, [data, isError]);

  // A logout unmounts this; the next session starts from the full list again.
  useEffect(
    () => () =>
      useConnectedServicesStore.setState({ services: CONNECTED_SERVICE_VALUES, settled: false }),
    []
  );

  return null;
}
